import { ComponentType } from 'react'
import { Categories } from './categories'
import { Footer } from './footer'
import { Hero } from './hero'

interface Props {
  zone: any
}

export const ExploreZone: ComponentType<Props> = ({ zone }) => (
  <>
    <Hero zone={zone} />
    <Categories zone={zone} />
    <Footer />
  </>
)
